/* eslint-disable react/jsx-indent */
import { Autocomplete, TableCell, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { FC } from 'react';
import TextField from 'components/text-field';
import { Controller, useFormContext } from 'react-hook-form';
import { ChargeFormEntry } from '../../../../types';
import { ListingEntry } from 'graphql/listings/queries';
import { extractData } from 'views/orders/new-charges/charges-e/components/document-fees-modal/services';
import { ChargesFormType } from '../../../../hooks';
import { autocompleteRootProps } from 'v2-utils/autocomplete';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.default,
      borderRadius: '5px',
      color: theme.palette.primary.dark,
      fontSize: '0.8rem',

      '& .MuiOutlinedInput-input': {
        padding: '10px !important',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: 'unset',
      },
    },
  },
  tableChargeRow: {
    padding: `8px ${theme.spacing(0.5)}`,
    fontSize: '0.8rem',
  },
}));

interface Props {
  charge: ChargeFormEntry;
  index: number;
  textPredectiveCharges: ListingEntry[];
  isDocument?: boolean;
  isReadOnly?: boolean;
}

export const DescriptionField: FC<Props> = ({
  index,
  charge,
  textPredectiveCharges,
  isDocument = false,
  isReadOnly = false,
}) => {
  const { getValues, control } = useFormContext<ChargesFormType>();
  const classes = useStyles();

  const filterDescription = (options, value) => {
    return options.filter((option) => option.toLowerCase().includes(value.toLowerCase()));
  };

  const description = isDocument
    ? extractData(getValues(`charges.${index}.description`))?.document ?? ''
    : getValues(`charges.${index}.description`) ?? '';

  const tooltipTitle = description.length > 20 ? description : '';

  if (charge.kind !== 'manual' || isReadOnly) {
    return (
      <Tooltip title={tooltipTitle}>
        <TableCell
          className={classes.tableChargeRow}
          style={{ paddingLeft: '10px', cursor: 'default' }}
        >
          {description}
        </TableCell>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltipTitle}>
      <TableCell className={classes.tableChargeRow}>
        <Controller
          name={`charges.${index}.description`}
          control={control}
          render={({ field: { onChange, ref, ...field } }) => (
            <Autocomplete
              {...field}
              ref={ref}
              freeSolo
              value={description}
              options={textPredectiveCharges.map((text) => text.description)}
              filterOptions={(options) => {
                const value = getValues(`charges.${index}.description`);
                if (value) {
                  return filterDescription(options, value);
                }
                return options;
              }}
              getOptionLabel={(option) => option}
              onInputChange={(_, value, reason) => {
                if (reason === 'input') {
                  onChange(value);
                }
              }}
              onChange={(_, value) => {
                onChange(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={params.InputProps.ref}
                  InputProps={autocompleteRootProps(params.inputProps)}
                  customClassName={classes.textField}
                  color="secondary"
                  variant="outlined"
                />
              )}
            />
          )}
        />
      </TableCell>
    </Tooltip>
  );
};
